import * as React from 'react';

interface IConditionalWrapperProps<S extends {}> {
  shouldWrap: boolean;
  Wrapper: React.ComponentType<S>;
  wrapperProps: S;
  children: React.ReactElement | React.ReactNode | React.ReactText;
}

/**
 * Компонент решает проблему условного враппинга
 * Построен на базе рендер-пропса 'wrapper'
 * */
export function ConditionalWrapper<S extends object>({
  shouldWrap,
  Wrapper,
  children,
  wrapperProps,
}: IConditionalWrapperProps<S>): React.ReactElement {
  if (shouldWrap) {
    return <Wrapper {...wrapperProps}>{children}</Wrapper>;
  }

  return children as React.ReactElement;
}

ConditionalWrapper.displayName = 'ConditionalWrapper';
